import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-scroll';
import { FaBriefcase } from 'react-icons/fa';

function Hero() {
  return (
    <section className="hero">
      <motion.div 
        className="hero-content"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <h2>Software Associate</h2>
        <div>
          <h1>Hello, <span className='name'>I'm Vignesh</span></h1>
          <p className="hero-subtitle">Building innovative software solutions at Tribus Point</p>
        </div>
        <div className="hero-cta">
          <Link to="projects" smooth={true} duration={500} offset={-80} aria-label="Scroll to projects section">
            <button className="cta-button primary" type="button">
              <FaBriefcase /> View My Work
            </button>
          </Link>
          <Link to="contact" smooth={true} duration={500} offset={-80} aria-label="Scroll to contact section">
            <button className="cta-button secondary" type="button">
              Get In Touch
            </button>
          </Link>
        </div>
      </motion.div>
    </section>
  );
}

export default Hero;
